export default "__VITE_ASSET__CwEhTmxf__"